import * as React from 'react';

import { CallCentreResetPasswordThankyouPage } from '../../pages/thankyou/CallCentreResetPasswordThankyouPage';
import { getWindow } from 'ts/window/Window';
import { getLoginBootstrapUrl } from 'ts/config/ConfigService';
import { RESULT_URL, USERNAME } from 'ts/constants/UrlParams';
import { Location } from 'history';

interface CallCentreResetPasswordWizardThankyouPageProps {
  location: Location;
}

const nextAction = (location: Location) => () => {
  const searchParams = new URLSearchParams(location.search);
  const username = searchParams.get(USERNAME);
  const resultUrl = searchParams.get(RESULT_URL);
  return resultUrl
    ? (getWindow().location.href = resultUrl)
    : (getWindow().location.href = getLoginBootstrapUrl() + `?${USERNAME}=${username}`);
};

const CallCentreResetPasswordWizardThankyouPage: React.FC<CallCentreResetPasswordWizardThankyouPageProps> = ({
  location,
}) => <CallCentreResetPasswordThankyouPage nextAction={nextAction(location)} />;

export { CallCentreResetPasswordWizardThankyouPage };
